import { render, staticRenderFns } from "./TheFichierImportationPage.vue?vue&type=template&id=64e405c7&"
import script from "./TheFichierImportationPage.vue?vue&type=script&lang=js&"
export * from "./TheFichierImportationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheFichierImportationPage.vue"
export default component.exports